import { Spinner } from './Spinner';
import { useFetchUser } from '../hooks/useFetchUser';
import { getFullName } from '../utils/common';

export const Avatar = () => {
  const { data: user, isLoading } = useFetchUser();

  return (
    <div className="flex items-center gap-2 pb-2 w-full">
      <div className="relative inline-flex items-center justify-center w-10 h-10 overflow-hidden bg-gray-100 rounded-full dark:bg-gray-600">
        {isLoading ? (
          <Spinner />
        ) : user ? (
          <span className="font-medium text-gray-600 dark:text-gray-300">
            {`${user.firstName[0]}${user.lastName[0]}`}
          </span>
        ) : (
          '--'
        )}
      </div>
      {user ? (
        <div className="flex-1 min-w-0">
          <p className="text-sm text-gray-900 dark:text-white text-ellipsis overflow-hidden whitespace-nowrap">
            {getFullName(user.firstName, user.lastName)}
          </p>
          <p className="text-sm font-medium text-gray-900 truncate dark:text-gray-300 text-ellipsis overflow-hidden whitespace-nowrap">
            {user.email}
          </p>
        </div>
      ) : null}
    </div>
  );
};
